import { type ComponentProps, type Ref } from "react";
import { TableHead as BaseTableHead } from "components/ui/table";
import { cn } from "utils";

export function TableHead({
  ref,
  ...props
}: ComponentProps<typeof BaseTableHead> & {
  ref?: Ref<HTMLTableCellElement>;
}) {
  return (
    <BaseTableHead
      ref={ref}
      {...props}
      className={cn("text-secondary-900", props.className)}
    />
  );
}

TableHead.displayName = "TableHead";
